import { Component, ElementRef, OnDestroy } from '@angular/core';
import { IHeaderParams } from 'ag-grid/main';
import { IHeaderAngularComp } from 'ag-grid-angular/main';

interface MyParams extends IHeaderParams {
  menuIcon: string;
}

@Component({
  selector: 'grid-header',
  moduleId: module.id,
  templateUrl: 'grid-header.component.html',
  styleUrls: ['grid-header.component.scss']
})

export class GridHeaderComponent implements IHeaderAngularComp, OnDestroy {
  public params: MyParams;
  public sorted: string;
  private elementRef: ElementRef;
  private sortCount = 0;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  agInit(params: MyParams): void {
    this.params = params;
    this.params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
    this.onSortChanged();
  }

  ngOnDestroy() {
    this.params.column.removeEventListener('sortChanged', this.onSortChanged.bind(this));
  }

  onSortRequested(event) {
    ++this.sortCount;
    let order = this.sortCount === 1 ? 'asc' : (this.sortCount === 2 ? 'desc' : '');
    if (this.sortCount > 2) {
      this.sortCount = 0;
    }
    this.params.setSort(order, event.shiftKey);
  }

  onSortChanged() {
    this.sorted = this.params.column.isSortAscending() ? 'asc' : (this.params.column.isSortDescending() ? 'desc' : '');
  }

  private querySelector(selector: string) {
    return <HTMLElement>this.elementRef.nativeElement.querySelector(
      '.customHeaderMenuButton', selector);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/assorted/grid-header.component.ts